<template>
  <div class="w-full h-48 bg-secondary my-6">
    <div class="ssc-wrapper">
      <div class="h-64 shaddow">
        <div class="ssc-square mb w-full h-64"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "skeleton-card-explore-movie-list"
};
</script>
